import { useCallback, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import handleException from "go-core/api/handleException";
import { ApiError } from "go-core/api/types";
import { apiPublic } from "../../../../../services/Api/Public/apiPublic";
import { OrderData } from "../../../../../services/Api/Public/types";

export const useOrder = (
	orderId: string,
	matchUrl: string,
	setOrder: (order: OrderData) => void,
	setOrderErrors: (errors: ApiError[]) => void,
	order?: OrderData,
	paymentSuccess?: boolean
): OrderData | undefined => {
	const history = useHistory();
	const location = useLocation();
	const urlSearchParams = new URLSearchParams(location.search);
	const orderPaymentStatus = urlSearchParams.get("orderTransactionStatus");

	const getOrder = useCallback(async () => {
		try {
			const newOrder = await apiPublic.getOrderData(orderId);

			if (newOrder) {
				return setOrder(newOrder);
			}

			history.push("/404_page");
		} catch (err) {
			const errs = handleException(err);
			const notFoundError = errs.find((error) => error.code === "not_found");

			if (notFoundError) {
				history.push("/404_page");
			} else {
				setOrderErrors(errs);
			}
		}
	}, [orderId, history, setOrder]);

	useEffect(() => {
		const isOnDefaultRoute = location.pathname === matchUrl;

		if (!isOnDefaultRoute) {
			if (!order) getOrder();
			return;
		}

		getOrder();

		const interval = setInterval(() => {
			getOrder();
		}, 5000);

		return () => clearInterval(interval);
	}, [getOrder, location.pathname, matchUrl, orderPaymentStatus, paymentSuccess]);

	return order;
};
